const formRootSelector = [
  '[data-forms-id="forms-root-1126841"]',
  '[data-forms-id="forms-root-1131813"]',
].join(',');
const styleId = 'lussommo-inline-form-width';

/**
 * Sets each supported Shopify Forms inline container to its natural width.
 * Shopify Forms renders inside an open shadow root, so theme CSS cannot target it directly.
 *
 * @returns {boolean} Whether every form currently on the page is ready and styled.
 */
function applyFormWidths() {
  const formRoots = document.querySelectorAll(formRootSelector);

  if (formRoots.length === 0) return false;

  let allFormsReady = true;

  formRoots.forEach((formRoot) => {
    const embed = formRoot.querySelector(':scope > shopify-forms-embed');
    const shadowRoot = embed?.shadowRoot;

    if (!shadowRoot) {
      allFormsReady = false;
      return;
    }

    if (shadowRoot.getElementById(styleId)) return;

    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = `
      #form-container-ref > section > section[data-sizing='form-wrapper'][role='dialog'] {
        width: auto !important;
      }
    `;

    shadowRoot.append(style);
  });

  return allFormsReady;
}

if (!applyFormWidths()) {
  let attempts = 0;
  let retryTimer;

  const stopWaiting = () => {
    observer.disconnect();
    window.clearInterval(retryTimer);
  };

  const tryApplyFormWidths = () => {
    attempts += 1;

    if (applyFormWidths() || attempts >= 150) {
      stopWaiting();
    }
  };

  const observer = new MutationObserver(() => {
    tryApplyFormWidths();
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
  retryTimer = window.setInterval(tryApplyFormWidths, 100);
}
